// @flow

import React from 'react';
import styles from './styles.scss';

const SuccessMessage = () => (
  <div className={styles.success}>
    {/* $FlowFixMe */}
    <div className={styles['success-content']}>
      <p>Your message has been sent.</p>
      <p>We will contact you ASAP.</p>
    </div>
  </div>
);

export default SuccessMessage;



// WEBPACK FOOTER //
// ./src/components/Contact/SuccessMessage.js